export class ActivityLogsSerializer {
  static deserialize = log => (
    log && {
      releasingUserName: log.releasing_user_name,
      reportDate: log.report_date,
      createdAt: log.created_at,
    }
  );
}
